export const firebaseFunctionsUrl = (endpoint: string) => {
  return import.meta.env.VITE_ENV === "LOCAL"
    ? `https://us-central1-focusmap-development.cloudfunctions.net/api/${endpoint}` //`http://127.0.0.1:5001/focusmap-development/us-central1/api/${endpoint}`
    : import.meta.env.VITE_ENV === "DEV"
    ? `https://us-central1-focusmap-development.cloudfunctions.net/api/${endpoint}`
    : `https://us-central1-focuspoint-98783.cloudfunctions.net/api/${endpoint}`;
};
